import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { segmentEventsNames, trackSegmentEvent } from '@app/utils/analytics'
import { getSessionIdSelector } from '@app/store/session'
import ZipCodeForm from '@ui/business-components/ZipCodeForm/ZipCodeForm'

import { PhoneLink } from '../PhoneLink'
import { MenuLink } from '../TopMenu/TopMenu'
import { PARENTS_URL } from '../TopMenu/data'

interface LoginSectionProps {
  hideLoginSection: boolean
}

const SectionWrapper = styled.div<{ hideLoginSection: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${({ theme }) => theme.device.laptopL} {
    ${({ hideLoginSection }) => hideLoginSection && 'display: none;'}
  }

  @media ${({ theme }) => theme.device.laptop} {
    display: flex;
  }
`

const StyledZipForm = styled(ZipCodeForm)`
  transition: opacity, 0.4s;
  display: none;

  input {
    height: 4.4rem;
    max-width: 18.3rem;
  }

  button {
    line-height: 2.4rem;
  }

  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`

const LoginSection = ({ hideLoginSection }: LoginSectionProps) => {
  const sessionId = useSelector(getSessionIdSelector)

  const handleClickLogin = () => {
    if (sessionId) {
      trackSegmentEvent(sessionId, segmentEventsNames.PARENT360_LOG_IN)
    }
  }

  return (
    <SectionWrapper hideLoginSection={hideLoginSection}>
      <MenuLink as="a" onClick={handleClickLogin} href={PARENTS_URL}>
        Login
      </MenuLink>
      <PhoneLink />
      <StyledZipForm silentError />
    </SectionWrapper>
  )
}

export default LoginSection
